module.exports = __webpack_public_path__ + "assets/img/driver-btn-a47e5f33.png";